export default {
  REGISTER: "register",
  FEEDBACK: "feedback",
  ABOUT: "about",
  LOGIN: "login",
  HOME: "home",
  IMAGE_MANAGER: "image-manager",
  PDF_MANAGER: "pdf-manager",
  USER_OBSERVED_PESTS: "observed-pests"
};
